import { view } from '@yola/ws-sdk';

/*
 *
 *  FACEBOOK_IFRAME_WIDTH is the default width of the facebook document.
 *  It is necessary for large resolution screens.
 *
 * */
const FACEBOOK_IFRAME_WIDTH = 4000;

const calcIframeSize = (iframeId) => {
  const iframeElement = view.accessors.getLiveElement(iframeId);
  const { width, height } = iframeElement.getBoundingClientRect();
  const aspectHeight = Math.ceil((height / width) * FACEBOOK_IFRAME_WIDTH);

  return {
    width: FACEBOOK_IFRAME_WIDTH,
    height: aspectHeight,
  };
};

export default calcIframeSize;
